import * as React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';

export const FormLoading: React.FC<{ label?: string; subLabel?: string }> = ({
  label = 'Working…',
  subLabel = 'Please wait'
}) => (
  <Stack
    sx={{ marginY: '64px !important' }}
    alignItems="center"
    justifyContent="center"
    flex={1}
  >
    <CircularProgress size={40} />
    <Typography variant="h6" textAlign="center">
      {label}
    </Typography>
    <Typography variant="body1" textAlign="center" color="text.secondary">
      {subLabel}
    </Typography>
  </Stack>
);
